import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b6799c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cover" }
const _hoisted_2 = ["data-edit", "innerHTML"]

import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1630.914 1628.802">
  <g transform="translate(239.946 -84.633)">
    <path d="M733.024,832.065l559.705-498.557V266.141L670.285,820.582v11.483Z" transform="translate(-906.73 551.935)" fill="var(--theme-color-2)" stroke="#fff" stroke-miterlimit="10" stroke-width="7"/>
    <path d="M-8790,1647.392-9984.864,2753.26v193.123L-8790,1851.151Z" transform="translate(9981 -1269)" fill="var(--theme-color-1)" stroke="#707070" stroke-width="1"/>
    <path d="M1229.99,266.141,670.285,764.7V991.842L1292.729,437.4V266.141Z" transform="translate(-328.5 202.176)" fill="var(--theme-color-1)" stroke="#fff" stroke-miterlimit="10" stroke-width="7"/>
    <path d="M1229.99,266.141,670.285,764.7v67.367l622.444-554.441V266.141Z" transform="translate(94.739 292.896)" fill="var(--theme-color-2)" stroke="#fff" stroke-miterlimit="10" stroke-width="7"/>
    <path d="M1315.561,81,876.392,472.189V650.823L1368.584,212.4V81Z" transform="translate(-111.368 7.133)" fill="var(--theme-color-2)" stroke="#fff" stroke-miterlimit="10" stroke-width="7"/>
    <path d="M-9387.432,2483.7l-543.718,496.89" transform="translate(9981 -1269)" fill="none" stroke="var(--theme-color-1)" stroke-width="5"/>
  </g>
</svg>

`;


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-cover-3',
  props: {
    useEdit: { type: Boolean },
    projectName: {},
    time: {},
    mainPageEnterpriseName: {},
    titlePosition: {},
    settleTimePosition: {},
    aspNamePosition: {},
    orderNumber: {},
    orderNumberPostion: {}
  },
  emits: ['posChange', 'valueChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { info, onPosChange, onValueChange } = useCover(emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info), (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        "data-edit": _ctx.useEdit,
        key: index,
        class: _normalizeClass({ [item.className]: true }),
        innerHTML: props[item.valueKey]
      }, null, 10, _hoisted_2)), [
        [_unref(vMove), {
        pos: props[item.posKey],
        change: (left, top) => _unref(onPosChange)(item.posKey, left, top)
      }],
        [_unref(vInput), {
        value: props[item.valueKey],
        change: (value) => _unref(onValueChange)(item.valueKey, value)
      }]
      ])
    }), 128)),
    _createElementVNode("div", {
      innerHTML: svg,
      class: "svg"
    })
  ]))
}
}

})